<!--
 * @Author: mzw
 * @Date: 2021-09-26 16:50:42
 * @LastEditors: 汪俊洪
 * @LastEditTime: 2023-03-27 15:31:39
 * @Description: 发票信息弹窗组件
-->
<template>
    <el-dialog title="发票详情" :visible.sync="billInfoVisible" :before-close="handleBillClose">
        <el-form class="billInfo" label-width="100px" label-position="right">
            <el-row>
                <h1 class="title">发票信息</h1>
                <el-form-item label="发票抬头：">{{billInfo.companyName}}</el-form-item>
                <el-form-item label="客户税号：">{{billInfo.taxpayerIdentity}}</el-form-item>
                <el-form-item label="开户行：">{{billInfo.openingBank}}</el-form-item>
                <el-form-item label="账户：">{{billInfo.bankAccountNo}}</el-form-item>
                <el-form-item label="地址：">{{billInfo.companyAddress}}</el-form-item>
                <el-form-item label="电话：">{{billInfo.companyPhone}}</el-form-item>
            </el-row>
            <el-row v-if="billInfo.payOrderInvoiceAddressRefactoryVo">
                <h1 class="title">收票信息</h1>
                <el-form-item label="收票联系人：">{{billInfo.payOrderInvoiceAddressRefactoryVo.receiveGoodsPerson}}</el-form-item>
                <el-form-item label="收票人电话：">{{billInfo.payOrderInvoiceAddressRefactoryVo.receiveGoodsPhone || '无'}}</el-form-item>
                <el-form-item label="收票地址：">{{billInfo.payOrderInvoiceAddressRefactoryVo.orderAddress || '无'}}</el-form-item>
            </el-row>
        </el-form>
      </el-dialog>
</template>
<script>
export default {
  props: {
    billInfo: {
      type: Object,
      default: () => {
        return {}
      }
    },
    billInfoVisible: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleBillClose () {
      this.$emit('handleBillClose')
    }
  }
}
</script>

<style lang='scss' scoped>
  @import '../common/dialogStyle.scss';
  .billInfo{
      h1{
          font-size: 16px;
      }
      .el-form-item {
            margin-bottom: 0;
        }
  }
</style>
